export enum CatalogueTranslationKeyEnum {
  PageTitle = "header.catalogue",
  TitleYourCourses = "catalogue.titleYourCourses",
  MessageWithoutCourseMatches = "catalogue.messageWithoutCourseMatches",
  SubdomainTitleYourCoursesKey = "titleYourCourses",
}
